import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { toastError } from '../../common/UI/Toasts';

const SimpleImageUpload = ({ currentImage, onImageChange, height = '200px', label = 'Upload Image' }) => {
  const [preview, setPreview] = useState(currentImage);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      toastError('Please upload a valid image file (JPG, PNG, or WebP)');
      return;
    }

    // Validate file size (max 5MB)
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      toastError('Image size should be less than 5MB');
      return;
    }

    // Create preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
      // Pass the image data back to parent
      onImageChange({
        location: reader.result,
        file: file,
        name: file.name,
      });
    };
    reader.readAsDataURL(file);
  };

  const handleRemove = () => {
    setPreview(null);
    onImageChange(null);
  };

  return (
    <div className="simple-image-upload">
      {preview ? (
        <div className="position-relative">
          <img
            src={preview}
            alt="Preview"
            style={{
              width: '100%',
              height: height,
              objectFit: 'cover',
              borderRadius: '8px',
              border: '2px solid #dee2e6',
            }}
          />
          <div className="mt-2 d-flex gap-2">
            <label className="btn btn-sm btn-outline-primary" style={{ cursor: 'pointer' }}>
              <i className="fas fa-sync-alt me-2"></i>Change Image
              <input
                type="file"
                accept="image/jpeg,image/jpg,image/png,image/webp"
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />
            </label>
            <Button variant="outline-danger" size="sm" onClick={handleRemove}>
              <i className="fas fa-trash me-2"></i>Remove
            </Button>
          </div>
        </div>
      ) : (
        <div
          style={{
            width: '100%',
            height: height,
            border: '2px dashed #dee2e6',
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f8f9fa',
            cursor: 'pointer',
          }}
        >
          <label style={{ cursor: 'pointer', textAlign: 'center', width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <i className="fas fa-cloud-upload-alt" style={{ fontSize: '3rem', color: '#6c757d', marginBottom: '1rem' }}></i>
            <p className="mb-0 text-muted">Click to upload image</p>
            <small className="text-muted">JPG, PNG or WebP (Max 5MB)</small>
            <input
              type="file"
              accept="image/jpeg,image/jpg,image/png,image/webp"
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
          </label>
        </div>
      )}
    </div>
  );
};

export default SimpleImageUpload;
